// styles
import { useTranslation } from "react-i18next";

import PrimaryButton from "../../../common/PrimaryButton";
import styles from "./styles.module.scss";

interface Props {
  handleClick: () => void;
}

const NoCard = ({ handleClick }: Props) => {
  const { t } = useTranslation();
  return (
    <div className={styles["container"]}>
      <img
        alt="card"
        src="/assets/images/svg/debitCard.svg"
        className={styles["image_container"]}
      />
      <div className={styles["text_wrapper"]}>
        <h2>{t("lbl_empty_bank_list_title")}</h2>
        <p className={"p1"}>{t("lbl_empty_bank_list_sub_title")}</p>
      </div>

      <div className={styles["button_wrapper"]}>
        <PrimaryButton id={`user_profile_add_account`} onClick={handleClick}>
          {t("lbl_button_add_account")}
        </PrimaryButton>
      </div>
    </div>
  );
};

export default NoCard;
